import { Injectable } from '@angular/core';
import { State, Store } from '@ngrx/store';
import { shareReplay } from 'rxjs/operators';
import { getErrorMessage, getLoading } from '../../reauth/reauth.reducers';

@Injectable({ providedIn: 'root' })
export class ReauthModalQueries {
  constructor(private readonly store: Store<State<any>>) {}

  errorMessage$ = this.store.pipe(
    getErrorMessage,
    shareReplay(1),
  );

  loading$ = this.store.pipe(
    getLoading,
    shareReplay(1),
  );
}
